import React from 'react';
import logo from '../../assets/icons/logo_brand.svg'; // 导入 logo 图片
import logoMini from '../../assets/icons/logo_mini.svg'; // 导入 logo 图片
import styles from './styles.module.scss';

const Logo: React.FC<{size?: string, style?: React.CSSProperties, hideText?: boolean}> = ({
    size, style, hideText
}) => {
    const sizeWithDefault = size || '2.5rem';
    function calcFontSize(size: string): string {
        const match = size.match(/^([0-9.]+)([a-zA-Z%]+)$/);
        if (!match) return size;
        const value = parseFloat(match[1]);
        const unit = match[2];
        return `${value * 0.8}${unit}`;
    }
    return (
        <div className={styles["navbar-logo"]} style={{fontSize: calcFontSize(sizeWithDefault), ...style}}>
            {hideText ?<img src={logoMini} style={{height: sizeWithDefault}}></img> : <img src={logo} style={{height: sizeWithDefault}} alt="Bustly Logo" className={styles["navbar-logo-img"]} />}
        </div>
    );
};

export default Logo;